import React from 'react';
import { motion } from 'framer-motion';
import NavLinks from './NavLinks';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

interface MobileMenuProps {
  onSignIn: () => void;
  onGetStarted: () => void;
  onClose: () => void;
}

export default function MobileMenu({ onSignIn, onGetStarted, onClose }: MobileMenuProps) {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleLinkClick = () => {
    setTimeout(onClose, 150);
  };

  const handleGetStartedClick = () => {
    const objectiveSection = document.getElementById('objective-selector');
    if (objectiveSection) {
      onClose();
      setTimeout(() => {
        objectiveSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        objectiveSection.focus();
      }, 150);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.3, ease: [0.645, 0.045, 0.355, 1.000] }}
      className="md:hidden overflow-hidden"
    >
      <div className="px-4 pt-2 pb-6" onClick={handleLinkClick}>
        <div className="flex flex-col space-y-1 mb-6">
          <NavLinks />
        </div>

        <div className="flex flex-col space-y-3 border-t border-gray-200 pt-6">
          {currentUser ? (
            <button
              onClick={() => {
                onClose();
                navigate('/dashboard');
              }}
              className="w-full bg-primary text-dark px-6 py-3 rounded-lg hover:bg-primary-hover transition-colors duration-200 font-medium"
            >
              Go to Dashboard
            </button>
          ) : (
            <>
              <button
                onClick={onSignIn}
                className="w-full text-center text-gray-600 hover:text-gray-900 font-medium py-3 rounded-lg border border-gray-200 hover:border-gray-300 transition-all duration-200"
              >
                Sign In
              </button>
              
              <button
                onClick={handleGetStartedClick}
                className="w-full bg-primary text-dark px-6 py-3 rounded-lg hover:bg-primary-hover transition-colors duration-200 font-medium"
              >
                Start My Journey →
              </button>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
}